import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
  useContext,
} from "react";
import { AgGridReact } from "ag-grid-react";
import {
  getInvPDF,
  printPDFFile,
  savePatientInvoice,
  deleteErpService,
  getInvPDFObject,
  savePatientInvoiceQuotation,
  searchQuotation,
} from "../ERPActions/erpActions";
import ConvertQuotationModal from "./ConvertQuotationModal";
import AddServiceCard from "../AddServiceCard";
import ConfirmDeleteDialog from "../ConfirmDeleteDialog";
import personDetailsService from "../../../core/services/personDetailsService";
import patientServices from "../../../core/services/patientServices";
import { addMonths, isBefore, isSameDay, parseISO, isValid } from "date-fns";
import { useDispatch } from "react-redux";
import { patientActions, doctorActions } from "../../../core/actions";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import {
  ERP_CURRENCY_OBJ,
  ERP_GENERATE_INVOICE_REQUEST,
  ERP_INVOICE_BILLING_STAGE,
  ERP_INVOICE_PAYMENT_MODE,
  ERP_LABEL_CANCEL,
  ERP_LABEL_CLOSE,
  ERP_LABEL_GENERATE_INVOICE,
  ERP_LABEL_MOVETOBILL,
  ERP_LABEL_NEW_INVOICE,
  ERP_LABEL_PAY_NOW,
  ERP_LABEL_PAYMENT_BACK_ICON,
  ERP_LABEL_PREVIEW_INVOICE,
  ERP_LOCATION_NAME_TO_LOCATION_ID_MAP,
  ERP_IN_PATIENT_BILLING_LOC_NAME,
  ERP_OUT_PATIENT_BILLING_LOC_NAME,
  PATIENT_VISIT_TYPE_OUT_PATIENT,
  ERP_VISIT_FIN_SUMMARY_TYPE_INV,
  ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
  ERP_VISIT_FIN_SUMMARY_TYPE_SO,
  ERP_BILLING_TYPE_NON_SO,
  MASTER_LOCATION_DATA_LOCATION_KEY,
  ERP_BILLING_TYPE_SO,
  ERP_LABEL_PRINT_INVOICE,
  PATIENT_VISIT_TYPE,
  DEFAULT_BILLING_LOCATION_BY_VISIT_TYPE,
  MESSAGE_TYPE,
  AG_GRID_REACT_MIN_ROW_HEIGHT,
  AG_GRID_REACT_HEADER_ROW_HEIGHT,
  COMPONENT_WISE_AG_GRID_PAGINATION_SIZE,
  COMPONENT_WISE_AG_GRID_PAGINATION,
  COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT,
  HMS_REPORT_TEMPLATE_TYPE,
  BILLING_LOCATION_NAMES,
  HMS_NEW_INVOICE_REPORT_TYPE,
  ERP_INVOICE_QUOTATION_TYPE,
  ERP_LABEL_GENERATE_INVOICE_QUOTATION,
} from "../../../core/constants/erpConstants";
import { useSelector } from "react-redux";
import { DataContext } from "../ERPBilling"; // Import the context from ERPServiceList
import { Document, Page } from "react-pdf";
import { Close } from "@mui/icons-material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PercentIcon from "@mui/icons-material/Percent";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import { CreditCard, FileCopyOutlined } from "@material-ui/icons";
import { vi } from "date-fns/locale";
import { format, utcToZonedTime } from "date-fns-tz";
import { helperServices } from "../../../shared/helper";
import { ValueFormatterService } from "ag-grid-community";
import ProtectedComponent from "../../common/ProtectedComponent";
import { All_Component_Name, ORG_DETAILS } from "../../../shared/constants";
import { generateBillHtml } from "../../printConvertion/DocumentConvert";
import HeaderFooterComponent from "../../printConvertion/HeaderAndFooter";
import { useOrganization } from "../../../configurations/OrganizationContext";
import { Loading } from "../Loading";
import NumericCellEditor from "../NumericCellEditor";
import { copyTextToClipboard } from "./Clipboard";
import { generateQuotationHtml } from "./quotationPrintUtils";

// import { useNavigate } from 'react-router-dom';

export default function ListERPQuotation(props) {
  const { searchInputRef } = props;
  // const navigate = useNavigate();
  const org = useOrganization();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedLocationDetail, setSelectedLocationDetail] = useState(props.selectedLocationDetails
  );
  const [locationId, setLocationId] = useState(0);
  const [columnDefs, setColumnDefs] = useState();
  const [rowData, setRowData] = useState([]);
  const [updateInvoiceCal, setUpdateInvoiceCal] = useState(false);
  const [gridDataType, setGridDataType] = useState();
  // Missing state vars added (were present in NewERPQuotation but missing here)
  const initialServiceForm = {
    quantity: 1,
    originalAmount: 0,
    discountAmount: 0,
    editamount: 0,
    doctor: "",
  };
  const [serviceForm, setServiceForm] = useState(initialServiceForm);

  const [isaddDisable, setIsaddDisable] = useState(false);
  const [rowInfo, setRowInfo] = useState();
  // Convert modal state
  const [convertModalOpen, setConvertModalOpen] = useState(false);
  const [convertQuotationData, setConvertQuotationData] = useState(null);
  // Patient/visit IDs — null in quotation mode (no patient context)
  const [patientId, setPatientId] = useState(props.patientId || null);
  const [visitId, setVisitId] = useState(props.visitId || null);
  // const [invDetails, setInvDetails] = useState();
  const [viewInvoiceDetails, setViewInvoiceDetails] = useState();
  const [showViewInvoicePage, setShowViewInvoicePage] = useState(false);
  const [viewCard, setviewCard] = useState(false);
  const [pdfData, setPdfData] = useState("");
  const [gvId, setGvId] = useState(0);
  const [totalInvAmtDisountDetails, setTotalInvAmtDisountDetails] = useState({
    discountType: "flat",
    discountValue: 0.0,
  });
  const [remarks, setRemarks] = useState("");
  const [billType, setBillType] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(null);
  const patientInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic
  );

  const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails
  );

  const containerStyle = useMemo(
    () => ({
      width: "100%",
      height: COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT.ERPQuotation,
    }),
    []
  );
  const gridStyle = useMemo(
    () => ({ alignItems: "start", height: "100%", width: "100%" }),
    []
  );
  const [printdata, setPrintData] = useState("");
  const [triggerAction, setTriggerAction] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [isBackgroundTransparent, setIsBackgroundTransparent] = useState(false);

  const getLocationId = () => {
    console.log("locationDetails : ", selectedLocationDetail);
    if (selectedLocationDetail && selectedLocationDetail.locationDetails) {
      return selectedLocationDetail.locationDetails.erpLocationDetails[0]
        .locationid;
    }
  };


  // set background colour on every row
  const rowStyle = {
    background: "white",
    display: "flex",
    justifyContent: "center",
    BorderBottom: "1px solid #D0D0D0",
  };

  let currentRowHeight;

  const updateRowHeight = (params) => {
    // get the height of the grid body - this excludes the height of the headers
    const bodyViewport = document.querySelector(".ag-body-viewport");
    if (!bodyViewport) {
      return;
    }
    const gridHeight = bodyViewport.clientHeight;
    // get the rendered rows
    const renderedRowCount = params.api.getDisplayedRowCount();
    // if the rendered rows * min height is greater than available height, just just set the height
    // to the min and let the scrollbar do its thing
    if (renderedRowCount * AG_GRID_REACT_MIN_ROW_HEIGHT >= gridHeight) {
      if (currentRowHeight !== AG_GRID_REACT_MIN_ROW_HEIGHT) {
        currentRowHeight = AG_GRID_REACT_MIN_ROW_HEIGHT;
        params.api.resetRowHeights();
      }
    } else {
      // set the height of the row to the grid height / number of rows available
      currentRowHeight = Math.floor(gridHeight / renderedRowCount);
      params.api.resetRowHeights();
    }
  };

  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
    };
  }, []);

  const getRowHeight = useCallback((params) => {
    return currentRowHeight;
  }, []);

  // const onGridReady = useCallback((params) => {
  //     minRowHeight = params.api.getSizesForCurrentTheme().rowHeight;
  //     currentRowHeight = minRowHeight;
  // }, []);

  const onFirstDataRendered = useCallback(
    (params) => {
      updateRowHeight(params);
    },
    [updateRowHeight]
  );

  const onGridSizeChanged = useCallback(
    (params) => {
      updateRowHeight(params);
    },
    [updateRowHeight]
  );

  // Add defaultColDef configuration
  const defaultColDef = useMemo(() => {
    return {
      // editable: true,
      sortable: true,
      flex: 1,
      filter: true,
      resizable: true,
      floatingFilter: true,
    };
  }, []);

  const newQuotationInvoiceColumnDefs = [
    {
      headerName: "Sl No.",
      field: "slNo",
      colId: "slNo",
      flex: 0.5,
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "SL No",
    },
    {
      headerName: "Service Description",
      field: "description",
      colId: "description",
      // editable: (params) => gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO,
      editable: true,
      flex: 2,
      cellClassRules: {
        "editable-cell": (params) => params.colDef.editable,
      },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Service Name",
    },
   {
  headerName: "Original Charges/per unit",
  field: "updatedOriginalPrice",
  colId: "originalPrice",

  editable: true,   // ✅ now always editable

  cellClassRules: {
    "editable-cell": () => true,  // optional
  },

  cellEditor: "NumericCellEditor",
  cellEditorParams: {
    decimalDigits: 2,
    maxValue: (params) => params.data.updatedOriginalPrice,
  },

  valueFormatter: (params) =>
    params.value != null ? params.value.toFixed(2) : "0.00",

  valueSetter: (params) => {
    params.data.updatedOriginalPrice = params.newValue;
    params.data.charges = params.newValue;
    return true;
  },

  cellStyle: { textAlign: "right" },
  tooltipValueGetter: () => "Original Price/per unit", // 🔥 fixed tooltip
}

    ,
    {
      headerName: "Discounted Charges/per unit",
      field: "charges",
      colId: "charges",
      hide: true,
      // editable: true,
      editable: (params) => {
        return params.data.originalPrice === 0;
      },
      cellEditor: "NumericCellEditor", // ✅ must match name in frameworkComponents
      cellEditorParams: {
        decimalDigits: 2,
      },
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      valueSetter: (params) => {
        params.data.charges = params.newValue;
        return true; // ✅ ensures grid updates
      },
      cellClassRules: {
        "editable-cell": (params) => params.data.originalPrice === 0,
      },
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "Charges",
    },
    {
  headerName: "Discount Charges/per unit",
  field: "discountCharges",
  colId: "discountCharges",

  editable: true,

  cellEditor: "NumericCellEditor",

  cellEditorParams: (params) => ({
    decimalDigits: 2,
    // maxValue: Number(params.data.updatedOriginalPrice) || 0,
  }),

  valueFormatter: (params) =>
    params.value != null ? Number(params.value).toFixed(2) : "0.00",

  valueSetter: (params) => {
    const original = Number(params.data.updatedOriginalPrice) || 0;
    let newDiscount = Number(params.newValue) || 0;

    // ✅ If discount > original → reset to 0
    if (newDiscount > original) {
      newDiscount = 0;
    }

    params.data.discountCharges = newDiscount;

    // Update charges
    params.data.charges = original - newDiscount;

    return true;
  },

  cellStyle: { textAlign: "right" },

  tooltipValueGetter: () =>
    "Discount must be less than or equal to Original Price",
}
,
    {
      headerName: "Units",
      field: "quantity",
      colId: "quantity",
      editable: true,
      flex: 0.5,
      cellEditor: "NumericCellEditor", // ✅ must match name in frameworkComponents
      cellEditorParams: {
        decimalDigits: 0,
      },
      valueSetter: (params) => {
        params.data.quantity = params.newValue;
        return true; // ✅ ensures grid updates
      },
      cellClassRules: {
        "editable-cell": (params) => params.colDef.editable,
      },
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Quantity",
    },
    {
      headerName: "Price",
      field: "price",
      colId: "price",
      valueGetter: "data.charges * data.quantity",
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Total Price",
    },
    {
      headerName: "Action",
      field: "action",
      editable: false,
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      cellRenderer: "ActionRenderer",
      tooltipField: "Action",
      autoHeight: true,
    },
  ];

  const viewQuotationInvoiceColumnDefs = [
    {
      headerName: "Invoice Line Id",
      field: "invoiceLineId",
      colId: "invoiceLineId",
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "SL No",
    },
    {
      headerName: "Service Name",
      field: "productName",
      colId: "productName",
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Product Name",
    },
    {
      headerName: "Original Charges/per unit",
      field: "originalPriceSell",
      colId: "originalPrice",
      cellStyle: { textAlign: "right" },
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "Original Price Inclusive of Tax",
    },
    {
      headerName: "Discount Charges/per unit",
      field: "discount",
      colId: "discount",
      valueGetter: "data.originalPriceSell - (data.unitPriceIncTax/(1+data.taxRate))",
      cellStyle: { textAlign: "right" },
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "Discount Charges Inc of Tax",
    },
    {
      headerName: "Tax Rate",
      field: "taxRate",
      colId: "taxRate",
      valueGetter: "data.taxRate",
      cellStyle: { textAlign: "right" },
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "TaxRate of the product",
    },
    // {
    //   headerName: "Discounted Charges/per unit",
    //   field: "unitPriceIncTax",
    //   colId: "unitPriceIncTax",
    //   cellStyle: { textAlign: "right" },
    //   valueFormatter: (params) => params.value.toFixed(2),
    //   // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
    //   //cellClass: ["ag-cell-center", "table-head"],
    //   tooltipField: "Discounted Charges Inc of Tax",
    // },
    {
      headerName: "Units",
      field: "units",
      colId: "units",
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Quantity",
    },
    {
      headerName: "Price",
      field: "price",
      colId: "price",
      valueGetter: "data.units * data.unitPriceIncTax",
      // valueFormatter: (params) => params.value.toFixed(2),
       valueFormatter: (params) => (params.value != null ? params.value.toFixed(2) : '0.00'),
      cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Total Price",
    },
    // {
    //     headerName: 'Action',
    //     field: 'action',
    //     // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
    //     cellRenderer: 'ActionRenderer',
    //     tooltipField: "Action",
    // },
  ];

  // Column defs updated to match actual QuotationInfo fields from backend
  const quotationInvoiceListColumnDefs = [
    {
      headerName: "Sl.No.",
      valueGetter: "node.rowIndex + 1",
      sortable: false,
      filter: false,
      width: 80,
      tooltipField: "Sl No",
    },
    {
      headerName: "Quote ID",
      field: "quoteId",
      colId: "quoteId",
      flex: 0.7,
      sortable: true,
      filter: true,
      tooltipField: "Quotation ID",
    },
    {
      headerName: "Patient Name",
      field: "customerName",
      colId: "customerName",
      sortable: true,
      filter: true,
      tooltipField: "Patient Name",
      valueGetter: (params) => {
        if (params.data.customerName) return params.data.customerName;
        if (params.data.customerId) return params.data.customerId;
        return "";
      }
    },
    {
      headerName: "Date",
      field: "dateNew",
      colId: "dateNew",
      sortable: true,
      filter: true,
      tooltipField: "Quotation Date",
      valueFormatter: (params) => {
        if (!params.value) return "";
        try {
          return new Date(params.value).toLocaleDateString("en-IN");
        } catch (e) {
          return params.value;
        }
      },
    },

    // {
    //   headerName: "Total Amount (₹)",
    //   field: "totalAmount",
    //   colId: "totalAmount",
    //   sortable: true,
    //   filter: true,
    //   cellStyle: { textAlign: "right" },
    //   valueGetter: (params) => {
    //     if (params.data?.lines && params.data.lines.length > 0) {
    //       return params.data.lines.reduce((acc, l) => {
    //         const grossPrice = l.mrp != null ? l.mrp : (l.priceSell != null ? l.priceSell : (l.price || 0));
    //         return acc + (grossPrice * (l.units || 1));
    //       }, 0);
    //     }
    //     const payable = parseFloat(params.data?.totalAmount) || 0;
    //     const discount = parseFloat(params.data?.discountRs) || 0;
    //     return payable + discount;
    //   },
    //   valueFormatter: (params) =>
    //     params.value != null ? `₹ ${parseFloat(params.value).toFixed(2)}` : "",
    //   tooltipField: "Total Amount",
    // },
    {
      headerName: "Bill Amount (₹)",
      field: "payableAmount",
      colId: "payableAmount",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "right" },
      valueGetter: (params) => {
        return parseFloat(params.data?.totalAmount) || 0;
      },
      valueFormatter: (params) =>
        params.value != null ? `₹ ${parseFloat(params.value).toFixed(2)}` : "",
      tooltipField: "Bill Amount",
    },
    {
      headerName: "Discount Amount (₹)",
      field: "discountRs",
      colId: "discountRs",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "right" },
      valueGetter: (params) => {
        if (params.data?.lines && params.data.lines.length > 0) {
          const totalDisc = params.data.lines.reduce((acc, l) => {
            const grossPrice = l.mrp != null ? l.mrp : (l.priceSell != null ? l.priceSell : (l.price || 0));
            const netPrice = l.price != null ? l.price : grossPrice;
            return acc + (Math.max(0, grossPrice - netPrice) * (l.units || 1));
          }, 0);
          if (totalDisc > 0) return totalDisc;
        }
        return parseFloat(params.data?.discountRs) || 0;
      },
      valueFormatter: (params) =>
        params.value != null ? `₹ ${parseFloat(params.value).toFixed(2)}` : "₹ 0.00",
      tooltipField: "Discount Amount",
    },
    {
      headerName: "Payable Amount (₹)",
      field: "payableAmount",
      colId: "payableAmount",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "right" },
      valueGetter: (params) => {
        return parseFloat(params.data?.totalAmount) || 0;
      },
      valueFormatter: (params) =>
        params.value != null ? `₹ ${parseFloat(params.value).toFixed(2)}` : "",
      tooltipField: "Payable Amount",
    },

    {
      headerName: "Action",
      field: "action",
      colId: "action",
      sortable: false,
      filter: false,
      width: 140,
      maxWidth: 160,
      minWidth: 120,
      cellRenderer: "ActionRenderer",
      cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
      tooltipField: "Action",
    },
  ];
  const getRowId = useCallback((params) => {
    return String(params.data.quoteId);
  }, []);

  // First, add the ActionRenderer component at the top of your file
  const ActionRenderer = (cellProps) => {
    console.log("ERPQuotation-actionrenderer_props: ", cellProps);
    // if(props.data){
    console.log("ERPQuotation-actionrenderer_props: ", cellProps.data);
    // }
    const onDelete = async () => {
      console.log("props.data.slNo: ", cellProps.data.slNo, cellProps.rowIndex);

      // Check if the row has soId and soLinID for ERP service deletion
      if (cellProps.data.soId && cellProps.data.soLineId) {
        try {
          console.log(
            "Deleting ERP service with soId:",
            cellProps.data.soId,
            "soLinID:",
            cellProps.data.soLineId
          );
          const resCb = await deleteErpService(
            patientId,
            visitId,
            cellProps.data.soId,
            cellProps.data.soLineId
          );
          console.log("ERP service deletion response:", resCb);
        } catch (error) {
          console.error("Error deleting ERP service:", error);
          // You might want to show an error message to the user here
          return; // Exit early if deletion fails
        }
      }

      // Get all row data from the grid
      const allRowData = cellProps.api
        .getModel()
        .rowsToDisplay.map((row) => row.data);
      console.log("allrowdata: ", allRowData);

      // Filter out the row to be deleted
      const updatedRows = allRowData
        .filter((row) => row.slNo !== cellProps.data.slNo)
        .map((row, index) => ({
          ...row,
          slNo: index + 1, // Update serial numbers
        }));

      console.log("updatedRows: ", updatedRows);
      console.log("updatedProps: ", cellProps.api);

      setRowData(updatedRows);
      // Update the grid with new data
      cellProps.api.setRowData(updatedRows);
    };

    const openDeleteDialog = () => {
      setPendingDelete(() => onDelete);
      setOpenConfirm(true);
    };

    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px", height: "100%" }}>
        {/* Delete button — only for new/unsaved rows */}
        {!(
          viewInvoiceDetails &&
          viewInvoiceDetails.type === ERP_VISIT_FIN_SUMMARY_TYPE_INV
          || (cellProps.data.billNumber != null || cellProps.data.isConsolidated || cellProps.data.soId != null)
        ) && (
          <div
            title="Delete"
            style={{ color: "#a32424", cursor: "pointer" }}
            onClick={openDeleteDialog}
          >
            <i className="material-icons" style={{ fontSize: "18px" }}>delete</i>
          </div>
        )}
        {/* Convert to Patient Invoice button */}
        <div
          title="Convert to Patient Invoice"
          style={{ color: "#1976d2", cursor: "pointer" }}
          onClick={() => {
            setConvertQuotationData(cellProps.data);
            setConvertModalOpen(true);
          }}
        >
          <i className="material-icons" style={{ fontSize: "18px" }}>person_add</i>
        </div>
        {/* View Quotation button */}
        {typeof props.onViewQuotation === "function" && (
          <div
            title="View Quotation"
            style={{ color: "#2e7d32", cursor: "pointer" }}
            onClick={() => props.onViewQuotation(cellProps.data)}
          >
            <i className="material-icons" style={{ fontSize: "18px" }}>visibility</i>
          </div>
        )}
        {/* Print Quotation button */}
        <div
          title="Print Quotation"
          style={{ color: "#455a64", cursor: "pointer" }}
          onClick={() => handlePrintQuotation(cellProps.data, "print")}
        >
          <i className="material-icons" style={{ fontSize: "18px" }}>print</i>
        </div>
      </div>
    );
  };

  const handlePrintQuotation = async (quoteRow, actionType = "print") => {
    try {
      setLoading(true);
      const htmlData = await generateQuotationHtml(quoteRow, {
        patientInfo,
        org,
        masterLocationDetails,
      });
      setPrintData(htmlData);
      setTriggerAction(actionType);
    } catch (err) {
      console.error("Error printing quotation:", err);
      if (typeof props.serverResposnes === "function") {
        props.serverResposnes(
          "Failed to generate quotation print: " + (err?.message || err),
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  // Initial setup
  useEffect(() => {
    console.log("ListERPQuotation mounted, props:", props);
    let locationDetail = props.selectedLocationDetails;
    setSelectedLocationDetail(locationDetail);
    setColumnDefs(quotationInvoiceListColumnDefs);
  }, []);

  const extractFilters = (tagList) => {
    const textTag = tagList?.find((t) => t?.type === "text");
    const dateTag = tagList?.find((t) => t?.type === "date");

    return {
      searchQuery: textTag ? textTag.value : "",
      dateFrom: dateTag ? dateTag.from : "",
      dateTo: dateTag ? dateTag.to : "",
    };
  };

  const locationDependency = JSON.stringify(props.selectedLocationDetails);
  const tagsDependency = JSON.stringify(props.searchtags);
  const dateRangeDependency = JSON.stringify(props.dateRange);

  // Fetch quotation list on mount, when location, search tags (Enter click), date range, or reload toggles
  useEffect(() => {
    if (!convertModalOpen) {
      fetchQuotationList();
    }
  }, [locationDependency, tagsDependency, dateRangeDependency, props.reload]);

  const fetchQuotationList = async () => {
    try {
      setLoading(true);
      const today = new Date();
      const defaultPast = new Date();
      defaultPast.setDate(today.getDate() - 30);
      const fmt = (d) => {
        if (!d) return "";
        if (d instanceof Date) return d.toISOString().split("T")[0];
        return String(d).split("T")[0];
      };

      const { searchQuery: tagSearch, dateFrom: tagDateFrom, dateTo: tagDateTo } = extractFilters(props.searchtags);
      const searchQuery = (tagSearch || "").trim();

      const startDate = tagDateFrom || props.dateRange?.start || fmt(defaultPast);
      const endDate = tagDateTo || props.dateRange?.end || fmt(today);

      const locationDetail = props.selectedLocationDetails;
      // Use flatMap so that when locationid is itself an array (the "ALL" location
      // case built in Filter.js), the IDs are flattened into a single flat array
      // instead of producing a nested array like [[1, 2, 3]].
      const locationIds = locationDetail
        ? (Array.isArray(locationDetail) ? locationDetail : [locationDetail])
            .flatMap((l) => {
              const id = l?.locationDetails?.erpLocationDetails?.[0]?.locationid;
              return Array.isArray(id) ? id : id != null ? [id] : [];
            })
        : null;

      const basePayload = {
        startDate: fmt(startDate),
        endDate: fmt(endDate),
        locationIds: locationIds && locationIds.length > 0 ? locationIds : null,
      };

      console.log("fetchQuotationList basePayload:", basePayload, "searchQuery:", searchQuery);

      let list = [];

      if (searchQuery) {
        // 1. Search patients by search string (name, phone, MAIN, aadhaar) via /v1/search
        let matchedPatients = [];
        try {
          const patientRes = await patientServices.patientSearch({
            bodyParams: { searchString: searchQuery, flag: "" },
            activeOnly: false,
            dateFrom: "",
            dateTo: "",
            page: 0,
            pageSize: 50,
          });
          matchedPatients = patientRes?.patientListCollection || [];
        } catch (patErr) {
          console.error("Error searching patients for quotation search:", patErr);
        }

        // Build a lookup map of patient by erpCustId
        const patientByCustId = {};
        matchedPatients.forEach((p) => {
          const cId = p?.erpCustId || p?.customerId;
          if (cId) patientByCustId[cId] = p;
        });

        const customerIds = Object.keys(patientByCustId).map(Number).filter((id) => id > 0);

        // Check if searchQuery is numeric (could also be a Quote ID or Bill Number)
        const isNumeric = /^\d+$/.test(searchQuery);
        const numericQuoteId = isNumeric ? parseInt(searchQuery, 10) : null;

        // Perform parallel queries to get union if both patient match and numeric quoteId exist
        const queries = [];
        if (customerIds.length > 0) {
          queries.push(searchQuotation({ ...basePayload, customerIdList: customerIds }));
        }
        if (numericQuoteId != null) {
          queries.push(searchQuotation({ ...basePayload, quoteIdList: [numericQuoteId] }));
        }

        if (queries.length > 0) {
          const results = await Promise.all(queries);
          const mergedMap = new Map();
          results.forEach((res) => {
            const resList = res?.quotationInfoList || [];
            resList.forEach((q) => {
              if (q && q.quoteId) {
                mergedMap.set(q.quoteId, q);
              }
            });
          });
          list = Array.from(mergedMap.values());
        } else {
          // No patient found and query is not numeric
          list = [];
        }

        // Decorate rows with matched patient info (phone, MAIN, etc.)
        list = list.map((q) => {
          const pat = patientByCustId[q.customerId];
          if (pat) {
            return {
              ...q,
              patientPhone: pat.phno || "",
              patientMain: pat.ipopnumber || pat.main || "",
              patientInfo: pat,
            };
          }
          return q;
        });
      } else {
        // No search query: fetch all quotations for date range and location
        const result = await searchQuotation(basePayload);
        list = result?.quotationInfoList || [];
      }

      console.log("fetchQuotationList final list:", list);
      setRowData(list);
      setColumnDefs(quotationInvoiceListColumnDefs);
    } catch (e) {
      console.error("fetchQuotationList error:", e);
      setRowData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("rowData: ", rowData);
    console.log("erp invoice locationDetail: ", selectedLocationDetail);
    console.log("erp invoice masterLocationDetails: ", masterLocationDetails);
  }, [rowData, columnDefs, props.selectedLocationDetails]);

  useEffect(() => {
    console.log("props data : ", props, patientInfo);
  }, []);

  const invoiceCalculation = (rowList, totalDiscountApplied) => {
    console.log("invoiceCalculation: ", rowList);
    let totalWDiscount = 0.0;
    let totalInvAmtWithoutDiscount = 0.0;
    let totalCustomerGrpWiseDiscountCharges = 0.0;
    let totalAmountWithDiscountEligibilityWDiscount = 0.0;
    let totalAmountWithDiscountEligibilityWODiscount = 0.0;
    let totalAmountWithoutDiscountEligibilityWDiscount = 0.0;
    let totalAmountWithoutDiscountEligibilityWODiscount = 0.0;
    if (rowList && rowList.length > 0) {
      // rowList.forEach((row) => {
      for (const row of rowList) {
        console.log("row cal: ", row);
        // row.

        console.log("org Details : ",org, "\n org constants: ",ORG_DETAILS);
        
        const discountedCharges = (row.quantity || 0) * (row.charges || 0);
        const totalWithoutDisAmount = (row.quantity || 0) * (row.updatedOriginalPrice || 0);
        totalCustomerGrpWiseDiscountCharges += (row.quantity || 0) * (row.charges || 0);

        totalWDiscount += discountedCharges;
        totalInvAmtWithoutDiscount += totalWithoutDisAmount;
        if ((row.isConsolidated || (row.isKPCreditDiscountApplicable && row.isKPCreditDiscountApplicable === true)) || (org.orgCode!==ORG_DETAILS.MNH_DETAILS.orgCode)) {
          totalAmountWithDiscountEligibilityWDiscount += discountedCharges;
          totalAmountWithDiscountEligibilityWODiscount += totalWithoutDisAmount;
        }

        if ((row.isKPCreditDiscountApplicable && row.isKPCreditDiscountApplicable === false && org.orgCode===ORG_DETAILS.MNH_DETAILS.orgCode)) {
          totalAmountWithoutDiscountEligibilityWDiscount += discountedCharges;
          totalAmountWithoutDiscountEligibilityWODiscount += totalWithoutDisAmount;
        }
        // let discountedCharges = row.quantity * row.charges;
        // let totalWithoutDisAmount = row.originalPrice == 0 ? row.quantity * row.charges :row.quantity * row.originalPrice;
        // totalWDiscount = totalWDiscount + discountedCharges;
        // totalInvAmtWithoutDiscount = totalInvAmtWithoutDiscount + totalWithoutDisAmount;
      }
      // );
    }

    let respData = {
      totalBeforeDiscount: totalInvAmtWithoutDiscount,
      customerGrpWiseDiscountCharges: totalCustomerGrpWiseDiscountCharges,
      calculatedDiscountAmount:
        // (billType && billType === ERP_LABEL_MOVETOBILL)? 
        (totalInvAmtWithoutDiscount - totalWDiscount),
      calculatedDiscountPerc: 0,
      //  : (totalInvAmtWithoutDiscount - totalWDiscount),
      totalAfterDiscount: totalWDiscount,
      totalAfterDiscountWithRoundOff: totalWDiscount,
      totalAmountWithDiscountEligibilityWDiscount: totalAmountWithDiscountEligibilityWDiscount,
      totalAmountWithDiscountEligibilityWODiscount: totalAmountWithDiscountEligibilityWODiscount,
      totalAmountWithoutDiscountEligibilityWDiscount: totalAmountWithoutDiscountEligibilityWDiscount,
      totalAmountWithoutDiscountEligibilityWODiscount: totalAmountWithoutDiscountEligibilityWODiscount,
      roundOff: 0.0,
    };

    if (totalDiscountApplied) {
      console.log("totalDiscountApplied: ", totalDiscountApplied);
      if (
        totalDiscountApplied.discountType === "percentage" &&
        totalDiscountApplied.discountValue > 0
      ) {
        respData.calculatedDiscountAmount =
          (respData.calculatedDiscountAmount) +
          (totalDiscountApplied.discountValue / 100) *
          (respData.totalAmountWithDiscountEligibilityWDiscount);
        console.log(
          "1calculatedDiscountAmount : ",
          respData,
          totalDiscountApplied
        );
        respData.totalAfterDiscount = respData.totalBeforeDiscount - respData.calculatedDiscountAmount;
        console.log(
          "2calculatedDiscountAmount : ",
          respData,
          totalDiscountApplied
        );
      } else {
        respData.calculatedDiscountAmount += parseFloat(
          totalDiscountApplied.discountValue
        );
        if (respData.totalAmountWithDiscountEligibilityWDiscount != 0 && totalDiscountApplied.discountValue != 0) {
          respData.calculatedDiscountPerc = (totalDiscountApplied.discountValue / (respData.totalAmountWithDiscountEligibilityWDiscount));
        }
        respData.totalAfterDiscount = respData.totalAfterDiscount - totalDiscountApplied.discountValue;
      }
    }
    let totalBillAmountWithRoundOff = helperServices.roundHalfUpInt(respData.totalAfterDiscount);
    console.log("totalBillAmountWithRoundOff:respdata :: ", totalBillAmountWithRoundOff, respData);
    //  if(respData.totalAfterDiscount > totalBillAmountWithRoundOff){
    //  respData.roundOff = respData.totalAfterDiscount - totalBillAmountWithRoundOff;
    // }else{
    respData.roundOff = (totalBillAmountWithRoundOff - (respData.totalAfterDiscount));//*(-1);
    // }
    respData.totalAfterDiscountWithRoundOff = totalBillAmountWithRoundOff;
    //respData.totalAfterDiscount - respData.roundOff;//*-1;
    console.log("invoice cal value : ", respData);
    return respData;
  };

  const updateRowData = async (propData) => {
    // const rowList = rowData;
    console.log("updateRowData: ", propData);

    if (propData.rowUpdate) {
      const inputData = propData.rowUpdate;
      console.log("inputData: ", inputData);
      if (ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE === inputData.type) {
        console.log("ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE: ", inputData);
        setColumnDefs(newQuotationInvoiceColumnDefs);
        await updateProdsToGrid(inputData);
      }

      if (ERP_VISIT_FIN_SUMMARY_TYPE_INV === inputData.type) {
        console.log("ERP_VISIT_FIN_SUMMARY_TYPE_INV: ", inputData);
        setColumnDefs(viewQuotationInvoiceColumnDefs);
        setViewInvoiceDetails(inputData);
        await updateInvoiceDetailsToGrid(inputData);
      }

      if (ERP_LABEL_PAYMENT_BACK_ICON === inputData.type) {
        console.log("ERP_LABEL_PAYMENT_BACK_ICON: ", inputData);
        setColumnDefs(newQuotationInvoiceColumnDefs);
        // setViewInvoiceDetails(inputData);
        let updatedData = [];
        // if(inputData.typePackage){
        //   updatedData = rowData.concat(inputData.newRowItems)
        // }
        var data = {
          discountType: "flat",
          discountValue: 0.0,
        };

        if (propData.rowUpdate.discountPerc > 0) {
          data.discountValue = propData.rowUpdate.discountPerc;
          data.discountType = "percentage";
        } else {
          data.discountValue = propData.rowUpdate.discountRs;
          data.discountType = "flat";
        }
        setTotalInvAmtDisountDetails(data);

        setRowData(inputData.newRowItems);
        // await updateInvoiceDetailsToGrid(inputData);
      }
      if (ERP_BILLING_TYPE_SO === inputData.type) {
        setBillType(ERP_BILLING_TYPE_SO);
        console.log("ERP_BILLING_TYPE_SO: ", inputData);
        setGridDataType(ERP_VISIT_FIN_SUMMARY_TYPE_SO);
        setColumnDefs(newQuotationInvoiceColumnDefs);
        setRowData(inputData.newRowItems);
      }

      if (ERP_INVOICE_QUOTATION_TYPE.NEW_INVOICE_QUOTATION === inputData.type) {
        setBillType(ERP_INVOICE_QUOTATION_TYPE.NEW_INVOICE_QUOTATION);
        console.log("ERP_INVOICE_QUOTATION_TYPE: ", inputData);
        setColumnDefs(newQuotationInvoiceColumnDefs);
        await updateProdsToGrid(inputData);
      }
    }
  };

  const updateProdsToGrid = async (newRow) => {
    let newRowList = [];
    // let newRow = props.rowUpdate;
    console.log("updateProdsToGrid:props :: ", props);
    console.log("updateProdsToGrid: ", newRow);

    let existingRowData = [...rowData];
    let prodAlreadyExist = false;
    // if (existingRowData.length > 0) {
    //   await existingRowData.map((row) => {
    //     if (row.prodId == newRow.prodId) {
    //       // row.quantity = row.quantity + 1;
    //       prodAlreadyExist = true;
    //     } else {
    //       newRowList.push(row);
    //     }
    //   });
    //   if (!prodAlreadyExist) {
    //     newRowList.push(newRow);
    //   }
    // } else {
    //   newRowList.push(newRow);
    // }

    if (newRow.typePackage) {
      newRowList = [...existingRowData];
      let rowLength = existingRowData.length;
      const totalPrice = newRow.originalAmount;
      for (const uService of newRow.serviceList) {
        uService.quantity = newRow.quantity;
        if (newRow.discountAmount && totalPrice > 0) {
          const originalCharges = uService.charges || 0;
          const weight = originalCharges / totalPrice;
          const discountForThisService = weight * (newRow.discountAmount || 0);
          const newCharges = originalCharges - discountForThisService;
          uService.editamount = Number(newCharges.toFixed(2));
          uService.charges = Number(newCharges.toFixed(2));
          uService.discountCharges = Number(discountForThisService.toFixed(2));
        }
        rowLength += 1;
        uService.slNo = rowLength;
        newRowList.push(uService);
      }
    } else {
      newRow.slNo = rowData.length + 1;
      newRowList = existingRowData.concat(newRow);
    }

    setRowData(newRowList);
  };

  const updateInvoiceDetailsToGrid = async (data) => {
    console.log("updateInvoiceDetailsToGrid: ", data);
    setRowData(data.invoiceLineItems);
  };

  const updateSODetailsToGrid = async (data) => {
    console.log("updateSODetailsToGrid: ", data);
    const salesOrderItems = data.serviceDetails.salesOrderLineItems;
    let rowList = [];
    setGridDataType(ERP_VISIT_FIN_SUMMARY_TYPE_SO);

    for (const lineItem of salesOrderItems) {
      const newRow = {
        date: lineItem.salesOrderDate,
        slNo: lineItem.ticketLine,
        soId: data.serviceDetails.soId,
        serviceName: lineItem.product,
        originalPrice: lineItem.originalPrice,
        updatedOriginalPrice: lineItem.updatedOriginalPrice,
        gridDataType: ERP_VISIT_FIN_SUMMARY_TYPE_SO,
        charges: lineItem.charges,
        quantity: lineItem.units,
        price: lineItem.price * lineItem.units,
        type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
        productDetail: lineItem,
        prodId: lineItem.reference,
        action: "delete",
      };
      rowList.push(newRow);
    }
    setRowData(rowList);
  };

  const updateMoveSOToBillDetailsToGrid = async (data) => {
    console.log("updateMoveSOToBillDetailsToGrid: ", data);

    let rowList = [];

    // Check if dataType is MoveToBill
    if (data.dataType === ERP_LABEL_MOVETOBILL) {
      setGridDataType(ERP_VISIT_FIN_SUMMARY_TYPE_SO);
      // Iterate through keys excluding 'dataType' and 'type'
      Object.keys(data).forEach((key) => {
        if (!isNaN(key)) {
          console.log("!isNaN(key) first condition");
          const lineItem = data[key];
          const cleanedAmount =
            parseFloat(
              (lineItem.amount || "").toString().replace(/[₹,\s]/g, "")
            ) || 0;

          // Clone lineItem and clean amount in productDetail
          const cleanedProductDetail = {
            ...lineItem,
            amount: cleanedAmount,
          };

          const newRow = {
            date: "",
            slNo: lineItem.slNo,
            soLineId: lineItem.soLinID,
            soId: lineItem.soId,
            serviceName: lineItem.productName,
            description: lineItem.productName,
            originalPrice: lineItem.originalPrice / lineItem.quantity,
            discountCharges: ((lineItem.originalPrice / lineItem.quantity) - (lineItem.netAmount / lineItem.quantity)),
            updatedOriginalPrice: lineItem.updatedOriginalPrice / lineItem.quantity,
            originalDiscountCharges: lineItem.originalPrice / lineItem.quantity,
            charges: (lineItem.netAmount / lineItem.quantity),
            quantity: lineItem.quantity,
            price: lineItem.netAmount / lineItem.quantity,
            type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
            productDetail: cleanedProductDetail, // 👈 Cleaned here!
            prodId: lineItem.prodId,
            isConsolidated: lineItem.isConsolidated,
            isKPCreditDiscountApplicable: lineItem.isKPCreditDiscountApplicable,
            ticketId: lineItem.ticketId,
            ticketLineId: lineItem.ticketLineId,
            billNumber: lineItem.billNumber,
            action: "delete",
          };

          rowList.push(newRow);
        }
      });
    } else {
      console.log("!isNaN(key) second condition");
      // Original logic here for other dataTypes (e.g. 'serviceDetails.salesOrderLineItems')
      const salesOrderItems = data.serviceDetails?.salesOrderLineItems || [];
      for (const lineItem of salesOrderItems) {
        const newRow = {
          date: lineItem.salesOrderDate,
          slNo: lineItem.ticketLine,
          soId: data.serviceDetails.soId,
          serviceName: lineItem.product,
          charges: lineItem.charges,
          quantity: lineItem.units,
          price: lineItem.price * lineItem.units,
          type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
          productDetail: lineItem,
          prodId: lineItem.reference,
          action: "delete",
        };
        rowList.push(newRow);
      }
    }

    setRowData(rowList);
  };

  const clearSelectedProductsProp = () => {
    props.clearProps(false);
  };

  const closeNewInvoice = () => {
    setRowData([]);
    setViewInvoiceDetails("");
    const discvalue = {
      discountType: "flat",
      discountValue: 0.0,
    };
    setTotalInvAmtDisountDetails(discvalue);
    setBillType("");
    // Navigate back to the quotation LIST (not tab 2)
    if (typeof props.onBackToList === "function") {
      props.onBackToList();
    } else if (typeof props.closeNewInvoice === "function") {
      props.closeNewInvoice("3"); // stay on quotation tab
    }
  };

  const generateInvoiceQuotation = async () => {
    // rowData
    let invoiceItemList = [];
    const invDetail = await populateInvDetails();
    console.log("generateInvoice: inv detail :: ", invDetail);
    if (
      rowData &&
      rowData.length > 0 &&
      invDetail.loc !== null &&
      invDetail.loc !== undefined
    ) {
      // let invoicePayments = [
      //   {
      //     total: invDetail.invoiceDetail.totalInvoiceAmount,
      //     name: "paperin",
      //     givenAmount: invDetail.invoiceDetail.totalInvoiceAmount,
      //   },
      // ];
      // invDetail.invoiceDetail.invoicePayments = invoicePayments;
      invDetail.invoiceDetail.narration = remarks;
      const invResp = await savePatientInvoiceQuotation(
        invDetail.loc,
        invDetail.invoiceDetail,
        invDetail.erpCustId
      );
      if (invResp && invResp?.erpResp?.quoteId > 0) {
        const savedQuoteId = invResp.erpResp.quoteId;
        if (typeof props.serverResposnes === "function") {
          props.serverResposnes(`Quotation #${savedQuoteId} saved successfully`, MESSAGE_TYPE.SUCCESS);
        }
        closeNewInvoice();
      }

      if (invResp && invResp.error) {
        props.serverResposnes(invResp.error, MESSAGE_TYPE.ERROR);
        // setMessageStrip({ success: invResp.messageStrip });
      }
      setTotalInvAmtDisountDetails({
        discountType: "flat",
        discountValue: 0.0,
      });
    }
  };

  async function getBillingLoc() {
    let loc;
    const locDetail = selectedLocationDetail ?? [];

    const isOutPatient = patientInfo?.visit?.type?.toLowerCase() === PATIENT_VISIT_TYPE.OUTPATIENT.toLowerCase();

    const hasAllLocationKey = locDetail.some((el) => el?.locationKey === "all");

    const locConfig = helperServices.getMasterLocationConfigByRole();

    /**
     * Resolve billing location by visit type (OP / IP)
     */
    const getBillingByVisitType = () =>
      helperServices.getFirstLocationIdByKey(
        masterLocationDetails,
        isOutPatient
          ? MASTER_LOCATION_DATA_LOCATION_KEY.OP_BILLING
          : MASTER_LOCATION_DATA_LOCATION_KEY.IP_BILLING
      );

    /**
     * Resolve billing location by config
     */
    const getBillingByConfig = () => {
      if (
        !locConfig ||
        locConfig.defaultBillingLocation ===
        DEFAULT_BILLING_LOCATION_BY_VISIT_TYPE
      ) {
        return getBillingByVisitType();
      }

      return helperServices.getFirstLocationIdByKey(
        masterLocationDetails,
        locConfig.defaultBillingLocation
      );
    };

    /**
     * ------------------------
     * MAIN RESOLUTION LOGIC
     * ------------------------
     */

    // Case 1: Single selected location (and not ALL)
    if (!hasAllLocationKey && locDetail.length === 1) {
      const locationId =
        locDetail[0]?.locationDetails?.erpLocationDetails?.[0]?.locationid;

      // ✅ Missing clause handled here
      if (Array.isArray(locationId)) {
        loc = getBillingByConfig();
      } else {
        loc = locationId;
      }
    }
    // Case 2: Multiple selections OR ALL selected
    else {
      loc = getBillingByConfig();
    }

    return loc;
  }

  async function allContainSantathi(selectedLocationDetail) {
    return selectedLocationDetail.every(item =>
      typeof item?.locationKey === 'string' &&
      item.locationKey.toLowerCase().includes('santathi')
    );
  }

  async function populateInvDetails() {
    const currentDate = new Date();
    console.log("current Date: ", currentDate);

    console.log("populateInvDetails:selectedLocationDetail : ", selectedLocationDetail);
    let clientCustId = (selectedLocationDetail && selectedLocationDetail.length === 1 && selectedLocationDetail[0].locationKey !== "all" && allContainSantathi(selectedLocationDetail))
      ? selectedLocationDetail[0].clientERPCustId
      : null;

    console.log("clientCustId: ", clientCustId);

    let invoiceDetail = { ...ERP_GENERATE_INVOICE_REQUEST };
    let loc = "";
    if (rowData && rowData.length > 0) {
      invoiceDetail.kpCash = props.isKpCash; // Review after obtaining payload structure
      invoiceDetail.billNo = null;
      invoiceDetail.type =
        gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO
          ? ERP_BILLING_TYPE_SO
          : ERP_BILLING_TYPE_NON_SO;

      if (gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO) {
        invoiceDetail.invReportType = HMS_NEW_INVOICE_REPORT_TYPE.SO_INVOICE;
      } else {
        invoiceDetail.invReportType =
          HMS_NEW_INVOICE_REPORT_TYPE.INDIVIDUAL_INVOICE;
      }
      invoiceDetail.date = `${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getDate()}`;
      invoiceDetail.refund = false;
      invoiceDetail.gvName = helperServices.getLoggedUserID(); //;
      invoiceDetail.patientId = patientId;
      invoiceDetail.visitId = visitId;
      invoiceDetail.invoiceLineItem = rowData;
      invoiceDetail.date = currentDate;
      invoiceDetail.erpCustId = clientCustId ? clientCustId : patientInfo.erpCustId;
      invoiceDetail.invoicePayments = "";
      invoiceDetail.newRowItems = [...rowData];
      invoiceDetail.billingStage = ERP_INVOICE_BILLING_STAGE;
      invoiceDetail.narration = remarks;
      let patientFullName = "";
      if (patientInfo.fname && patientInfo.mname && patientInfo.lname) {
        patientFullName =
          patientInfo.fname + " " + patientInfo.mname + " " + patientInfo.lname;
      } else {
        patientFullName = patientInfo.fname + " " + patientInfo.lname;
      }
      invoiceDetail.m_sCustomerName = patientFullName;
      invoiceDetail.customerId = patientInfo.erpCustId;
      invoiceDetail.billType = "SL";
      invoiceDetail.location = loc;
      invoiceDetail.salesperson = "Support";
      invoiceDetail.narration = "";
      invoiceDetail.custome1 = "";
      invoiceDetail.custome2 = "";
      invoiceDetail.custome3 = "";
      if (
        totalInvAmtDisountDetails &&
        totalInvAmtDisountDetails.discountType === "flat"
      ) {
        invoiceDetail.discountRs = `${totalInvAmtDisountDetails.discountValue}`;
        invoiceDetail.discountPerc = `${invoiceCalculationResp.calculatedDiscountPerc}`;
        invoiceDetail.discountType = "flat";
        invoiceDetail.custom2 = "flat";
        invoiceDetail.custome2 = "flat";
      }
      if (
        totalInvAmtDisountDetails &&
        totalInvAmtDisountDetails.discountType === "percentage"
      ) {
        invoiceDetail.discountRs = `${invoiceCalculationResp.calculatedDiscountAmount}`;
        invoiceDetail.discountPerc = `${totalInvAmtDisountDetails.discountValue / 100}`;
        invoiceDetail.discountType = "percentage";
        invoiceDetail.custom2 = "percentage";
        invoiceDetail.custome2 = "percentage";
      }
      invoiceDetail.roundOffQaulifier = "ROUND_OFF_UP_OR_DOWN";
      invoiceDetail.roundOff = invoiceCalculationResp.roundOff;
      invoiceDetail.currencyId = ERP_CURRENCY_OBJ.id;
      invoiceDetail.m_aLines = [];
      invoiceDetail.invoicePayments = [];
      invoiceDetail.m_dDate = currentDate; //`${currentDate.getDate()}-${currentDate.getMonth()}-${currentDate.getFullYear()}`,

      let invoiceTotalAmount = 0.0;
      let invLineItemList = [];
      let invPaymentDetail = [];
      invoiceDetail.invoiceTotalAmount = (
        invoiceCalculationResp.totalAfterDiscountWithRoundOff
      ).toFixed(2);
      invoiceDetail.m_aLines = invLineItemList;
      invoiceDetail.invoicePayments = invPaymentDetail;
      invoiceDetail.totalInvoiceAmount = (
        invoiceCalculationResp.totalAfterDiscountWithRoundOff
      ).toFixed(2);
    }

    loc = await getBillingLoc();

    const invPopulateObj = {
      loc: loc,
      invoiceDetail: invoiceDetail,
      erpCustId: clientCustId,
    };
    // setInvDetails(invPopulateObj);
    return invPopulateObj;
  }

  const printInvoice = async (invDetail, actionType, templateReportType) => {
    setIsDisable(true);
    setLoading(true);
    setIsBackgroundTransparent(true);
    console.log("print inv: ", invDetail);

    console.log("print inv viewInvoiceDetails: ", viewInvoiceDetails);
    let ticketId = viewInvoiceDetails.ticketId;
    let customerId = patientInfo.erpCustId;
    let visitId = null;
    let reportType = null;
    let locationIds = null;
    const printPDF = await getInvPDFObject(
      ticketId,
      visitId,
      customerId,
      reportType,
      locationIds
    );
    // if (printPDF instanceof Blob) {
    //   const blobURL = URL.createObjectURL(printPDF);
    //   setPdfData(printPDF);
    //   const pdfWindow = window.open(blobURL, "_blank");
    // } else {
    //   const blobURL = printPDF;
    //   setPdfData(printPDF);
    //   const pdfWindow = window.open(blobURL, "_blank");
    // }
    // await printInvoicePDF(printPDF);

    // Navigate programmatically and pass state
    // navigate(`/invoice/${invoiceId}`, {
    //   state: {
    //     type: invoiceType,
    //     locationids: invoiceLocationIds,
    //   },
    // });
    // setShowViewInvoicePage(true);
    // viewInvoicePage(blobURL);

    const data = await generateBillHtml(
      printPDF.hmsInvReportDTOList,
      templateReportType,
      org?.orgCode
    );
    console.log("Generated HTML Data: ", data);

    setPrintData(data);
    setTriggerAction(actionType);
    setIsDisable(false);
    setLoading(false);
    setIsBackgroundTransparent(false);
  };

  const printInvoicePDF = async (invDetail, actionType, templateReportType) => {
    setIsDisable(true);
    setLoading(true);
    setIsBackgroundTransparent(true);
    console.log("print inv: ", invDetail);

    console.log("print inv viewInvoiceDetails: ", viewInvoiceDetails);
    let ticketId = viewInvoiceDetails.ticketId;
    let visitId = null;
    let customerId = patientInfo.erpCustId;
    let reportType = null;
    let locationIds = null;
    const printPDF = await getInvPDFObject(
      ticketId,
      visitId,
      customerId,
      reportType,
      locationIds
    );
    // const blobURL = URL.createObjectURL(printPDF);
    // Assuming 'printPDF' is the variable you want to check
    // if (printPDF instanceof Blob) {
    //   // You can proceed with creating the FormData and sending it
    //   console.log("printPDF is indeed a Blob object!");

    //   // Create FormData if using multipart/form-data
    //   const formData = new FormData();
    //   formData.append("file", printPDF, "invoice.pdf");

    //   // const arrayBuffer = await printPDF.arrayBuffer();

    //   const printResp = await printPDFFile(formData);
    //   console.log("printResp :", printResp);
    // } else {
    //   console.error("printPDF is NOT a Blob object. It is:", printPDF);
    //   // Handle the case where it's not a Blob (e.g., show an error, convert it, etc.)
    // }
    const data = await generateBillHtml(
      printPDF.hmsInvReportDTOList,
      templateReportType,
      org.orgCode
    );
    console.log("Generated HTML Data: ", data);

    setPrintData(data);
    setTriggerAction(actionType);
    setIsDisable(false);
    setLoading(false);
    setIsBackgroundTransparent(false);
  };

  const handleCloseViewInvoicePage = () => {
    setShowViewInvoicePage(false);
  };

  // function viewInvoicePage(blobUrl) {
  //   setShowViewInvoicePage(true);
  //
  //   return (
  //
  //   );
  // }
  // if(showViewInvoicePage){
  //   return (
  //   );
  // }

  const showPaymentPage = async () => {
    const invResp = await populateInvDetails();
    console.log("invResp: ", invResp);
    if (typeof props.invPaymentDetails === "function") {
      props.invPaymentDetails(invResp);
    }
    setTotalInvAmtDisountDetails({
      discountType: "flat",
      discountValue: 0.0,
    });
  };

  const handleDiscountTypeChange = (event) => {
    console.log("handleDiscountTypeChange: ", event);
    console.log("handleDiscountTypeChange1: ", event.target.value);
    // if(totalInvAmtDisountDetails.discountType==='flat'){
    let data = {
      discountType: event.target.value,
      discountValue: 0.0,
    };
    setTotalInvAmtDisountDetails(data);
    // }else {
    //   let data = {
    //     discountType: 'flat',
    //     discountValue: 0.0,
    //   }
    //   setTotalInvAmtDisountDetails(data);
    // }
  };

  const handleCancelAdd = () => {
    props.clearProps(true);
    setviewCard(false);
    setServiceForm(initialServiceForm);
    console.log("addservice after cancel", rowData);
  };

  const handleAdd = async (event) => {
    if (searchInputRef?.current) {
      searchInputRef.current.focus();
    }
    setIsaddDisable(true);
    await updateRowData({
      ...props,
      rowUpdate: {
        ...props.rowUpdate,
        ...serviceForm,
        description: rowInfo.description,
        charges: serviceForm.editamount,
        discountCharges: serviceForm.discountAmount,
        updatedOriginalPrice: serviceForm.originalAmount,
      },
    });
    setviewCard(false);
    setServiceForm(initialServiceForm);
    setIsaddDisable(false);
  };




  const handleDiscountValueChange = (event) => {
    console.log("handleDiscountValueChange: ", event);
    console.log("data value: ", event.target.value, invoiceCalculationResp);
    let netAmountValueAfterDiscount = 0.0;
    if (totalInvAmtDisountDetails.discountType === "flat") {
      let discountedAmount =
        event.target.value === "" ? 0.0 : parseFloat(event.target.value);
      netAmountValueAfterDiscount =
        invoiceCalculationResp.totalAmountWithDiscountEligibilityWDiscount -
        discountedAmount;
    }
    console.log(
      "netAmountValueAfterDiscount value: ",
      netAmountValueAfterDiscount
    );
    if (
      (totalInvAmtDisountDetails.discountType === "flat" &&
        netAmountValueAfterDiscount >= parseFloat(0.0)) ||
      (totalInvAmtDisountDetails.discountType === "percentage" &&
        event.target.value <= 100)
    ) {
      let discountedValue = event.target.value === "" ? 0.0 : parseFloat(event.target.value);
      let data = {
        discountType: totalInvAmtDisountDetails.discountType,
        discountValue: discountedValue,
      };
      console.log(
        "TotalInvAmtDisountDetails value: ",
        totalInvAmtDisountDetails
      );
      setTotalInvAmtDisountDetails(data);
    }
  };

  // The factorial will only be re-calculated when 'number' changes.
  const invoiceCalculationResp = useMemo(
    () => invoiceCalculation(rowData, totalInvAmtDisountDetails),
    [rowData, updateInvoiceCal, totalInvAmtDisountDetails]
  );

  const handleCellEdit = (params) => {
    const updatedRow = params.data;
    const column = params.colDef.field;
    const newValue = params.newValue;
    const oldValue = params.oldValue;
    console.log("handleCellEdit: ", params);

    if (newValue !== oldValue) {
      console.log("Edited field:", column);
      console.log("Old value:", oldValue);
      console.log("New value:", newValue);
      console.log("Updated row:", updatedRow);
    }
  };

  // if (loading) {
  //     // return <div className="d-flex justify-content-center align-items-center">Loading...</div>;
  //     return (
  //       <div className="d-flex justify-content-center align-items-center h-100 m-3">
  //         <Loading isBackgroundTransparent={isBackgroundTransparent} />
  //       </div>
  //     );
  //   }

  return (
    <>
      {/* Quotation listing grid */}
      <div className="ms-1" style={containerStyle}>
        <div
          className="ag-theme-balham ag-style ag-header-left px-1 py-2 w-100 h-100"
          style={gridStyle}
        >
          <AgGridReact
            rowData={rowData}
            pagination={COMPONENT_WISE_AG_GRID_PAGINATION.ERPQuotation}
            paginationPageSize={COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.ERPQuotation}
            columnDefs={quotationInvoiceListColumnDefs}
            suppressRowClickSelection
            frameworkComponents={{ ActionRenderer: ActionRenderer }}
            defaultColDef={defaultColDef}
            headerHeight={AG_GRID_REACT_HEADER_ROW_HEIGHT}
            context={{
              onRowClick: props.onRowClick,
              showMessageStrip: props.serverResposnes,
            }}
          />
        </div>
      </div>

      {/* Actions below ag grid */}
      <div className="d-flex justify-content-end px-2 py-1">
        <Button
          variant="contained"
          startIcon={<i className="material-icons" style={{ fontSize: "18px" }}>add</i>}
          onClick={() => typeof props.onNewQuotation === "function" && props.onNewQuotation()}
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            fontSize: "13px",
            textTransform: "none",
            borderRadius: "6px",
            "&:hover": { backgroundColor: "#4338ca" },
          }}
        >
          New Quotation
        </Button>
      </div>

      {/* Convert to Patient Modal */}
      {convertModalOpen && convertQuotationData && (
        <ConvertQuotationModal
          open={convertModalOpen}
          quotationData={convertQuotationData}
          onClose={() => {
            setConvertModalOpen(false);
            setConvertQuotationData(null);
          }}
          onSuccess={() => {
            setConvertModalOpen(false);
            setConvertQuotationData(null);
            fetchQuotationList(); // refresh the list
          }}
          serverResposnes={props.serverResposnes}
          selectedLocationDetails={props.selectedLocationDetails}
          masterLocationDetails={masterLocationDetails}
        />
      )}

      {/* Confirm delete dialog */}
      <ConfirmDeleteDialog
        open={openConfirm}
        title="Delete Quotation Item"
        message="Are you sure you want to delete this item?"
        showReason={false}
        onCancel={() => setOpenConfirm(false)}
        onConfirm={async () => {
          if (pendingDelete) await pendingDelete();
          setOpenConfirm(false);
        }}
      />

      {printdata && triggerAction && (
        <HeaderFooterComponent
          title="Quotation"
          data={printdata}
          triggerAction={triggerAction}
          onComplete={() => {
            setPrintData("");
            setTriggerAction("");
            console.log("Quotation print action completed and state cleared.");
          }}
        />
      )}
    </>
  );
}
